import React, { useEffect, useState, useReducer, useCallback } from 'react';
import { useReducerAsync } from 'use-reducer-async';
import { faEdit, faArrowRight, faArrowLeft, faCheck, faCross, faCrosshairs, faXmark, faNotdef } from '@fortawesome/free-solid-svg-icons'
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { BusinessBillFormDataReducer, businessBillFormDataInitialState } from './BusinessBillFormDataReducer';
import { BusinessAccountBillFormValidationReducer, businessAccountBillValidationInitialState } from './BusinessBillFormValidationReducer';
import { getBills, getAccountTypes, getAccountType } from '../business-bills/BusinessBillsService';
import { Table, Card, Button, Row, Col } from 'react-bootstrap';
import { AsyncBusinessBillDataHandlers } from './BusinessBillFormDataReducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PAGE_SIZE } from '../../config/config';
import _ from "lodash";
import { extractError } from 'api/ErrorUtil';
import { getBillStatus } from 'util/Lookup';
import { FormContainer } from 'uiwidgets/FormContainer';
import { FormField } from 'uiwidgets/FormField';
import { isValidDate } from 'util/Validators';
import { formatDate,stringDateToUTC,stringUTCToLocal,stringToDateBeginningOfDayUTC } from 'util/Date';

function BusinessBills() {
  const navigate = useNavigate();
  const [formData, formDispatchBusinessBills] = useReducerAsync(BusinessBillFormDataReducer, businessBillFormDataInitialState, AsyncBusinessBillDataHandlers);
  const [formValidityData, formValidityDispatch] = useReducer(BusinessAccountBillFormValidationReducer, businessAccountBillValidationInitialState)
  const [currentPage, setCurrentPage] = useState(0);
  const [totalNumberOfPages, setTotalNumberOfPages] = useState(0);
  const [clearFilterData, setClearFilterData] = useState("");

  const onToastClose = () => {
    formDispatchBusinessBills({ type: 'CLEAR_INFO_AND_ERROR' });
  }

  const fetchAccountTypes = useCallback(async () => {
    try {
      let types = await getAccountTypes();
      formDispatchBusinessBills({ type: 'FIELD_EDIT', payload: { name: 'accountTypes', value: types } });
    } catch (err) {
      let errors = extractError(err);
      formDispatchBusinessBills({ type: 'ERROR', payload: { errors: errors } });
    }
  });

  useEffect(() => {
    fetchAccountTypes();
  }, [])

  const fetchBillsDataForce = async () => {
    try {
      let billsPage = await getBills(0, PAGE_SIZE);
      let billsList = billsPage.billMessages;
      formDispatchBusinessBills({ type: 'FIELD_CLEAR_FILTERS', payload: { name: 'billsData', value: billsList } });
      setTotalNumberOfPages(billsPage.totalNumberOfPages)
      setCurrentPage(0);
    } catch (err) {
      let { message, errors, httpStatus } = extractError(err);
      if (httpStatus === 404) {
        formDispatchBusinessBills({
          type: 'FIELD_EDIT', payload: {
            name: 'billsData', value: [], infoMessage: "No bills were found", errors: errors
          }
        });
      } else {
        formDispatchBusinessBills({ type: 'ERROR', payload: { errors: errors } });
      }
    }
  }
  useEffect(() => {
    if (clearFilterData && clearFilterData.trim !== "") {
      fetchBillsDataForce();
    }
  }, [clearFilterData])

  const fetchBillsData = useCallback(async () => {
    try {

      let billsPage = await getBills(currentPage, PAGE_SIZE, formData.keyword,
        isValidDate(formData.fromBillDate) ? stringToDateBeginningOfDayUTC(formData.fromBillDate) : "",
        isValidDate(formData.toBillDate) ? stringToDateBeginningOfDayUTC(formData.toBillDate) : "");
      let billsList = billsPage.billMessages;
      formDispatchBusinessBills({ type: 'FIELD_EDIT', payload: { name: 'billsData', value: billsList } });
      setTotalNumberOfPages(billsPage.totalNumberOfPages)
    } catch (err) {
      let { message, errors, httpStatus } = extractError(err);
      if (httpStatus === 404) {
        formDispatchBusinessBills({
          type: 'FIELD_EDIT', payload: {
            name: 'billsData', value: [], infoMessage: "No bills were found", errors: errors
          }
        });
      } else {
        formDispatchBusinessBills({ type: 'ERROR', payload: { errors: errors } });
      }
    }
  });

  useEffect(() => {
    fetchBillsData();
  }, [currentPage])

  useEffect(() => {
    if (formData.keyword.length > 3) {
      console.log("Fetching bills for filter grater than 3")
      if (currentPage !== 0) {
        setCurrentPage(0);
      } else {
        fetchBillsData();
      }
    }
  }, [formData.keyword]);

  useEffect(() => {
    if (formData.fromBillDate && formData.toBillDate) {
      setCurrentPage(0);
    }
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      fetchBillsData();
    }
  }, [formData.fromBillDate, formData.toBillDate]);

  const handlePaging = async (page) => {
    if (page < 0) {
      alert("Reached the beginning of data set")
      page = 0;
    }
    if (page > totalNumberOfPages - 1) {
      alert("Reached the end of data set")
      page = totalNumberOfPages - 1;
    }
    setCurrentPage(page);
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formDispatchBusinessBills({ type: 'FIELD_EDIT', payload: { name: name, value: value } })
  }

  const handleValidation = (event) => {
    let dispatchType = 'VALIDATE_' + event.target.name.toUpperCase();
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formValidityDispatch({ type: dispatchType, payload: { [name]: value } })

  }
  const handleFilterKeyDown = async (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      fetchBillsData();
    }
  };
  const clearFilter = async (event) => {
    setClearFilterData(Date.now());
  };

  return (
    <FormContainer title="Bills/Invoices" toastCloseFunc={onToastClose} errors={formData.errors} infoMessage={formData.infoMessage} >
      <Row><Col>
        To create a new Bill, navigate to the  <Link to="/businessaccounts">Accounts List Page</Link> and click on the New Bill icon.
      </Col></Row>
      <Row>
        <Col sm={12} md={4} lg={4}>
          <FormField name="keyword" label="Keyword" type="text" value={formData.keyword}
            placeholder="Bill Number, Account Number, email" onChange={handleChange}
            onBlur={handleValidation} onKeyDown={handleFilterKeyDown}
            valstate={!formValidityData.keywordError} valMsg={formValidityData.keywordErrMsg} />
        </Col>
        <Col sm={6} md={2} lg={2}>
          <FormField name="fromBillDate" label="From Bill Date" type="date" value={formData.fromBillDate}
            placeholder="Enter From Bill Date" onChange={handleChange} onBlur={handleValidation}
            valstate={!formValidityData.fromBillDateError} valMsg={formValidityData.fromBillDateErrMsg} />
        </Col>
        <Col sm={6} md={2} lg={2}>
          <FormField name="toBillDate" label="To Bill Date" type="date" value={formData.toBillDate}
            placeholder="Enter To Bill Date" onChange={handleChange} onBlur={handleValidation}
            valstate={!formValidityData.toBillDateError} valMsg={formValidityData.toBillDateErrMsg} />
        </Col>
        <Col sm={6} md={2} lg={2}>
          <br />
          <Button variant="info" className="border-0 btn-fill" onClick={clearFilter}><strong><small>Clear Filter</small></strong></Button>
        </Col>
      </Row>

      {!_.isEmpty(formData.billsData) &&
        <Row>
          <Col className='d-flex justify-content-end'>
            <Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage - 1) }}>
              <h6><FontAwesomeIcon icon={faArrowLeft} onClick={(event) => { handlePaging(currentPage - 1) }} />Previous Page</h6>
            </Button>
            &nbsp;<span className="border-0 text-dark btn"><h6>{currentPage + 1} of {totalNumberOfPages}</h6></span>
            &nbsp;<Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage + 1) }}>
              <h6>Next Page<FontAwesomeIcon icon={faArrowRight} /></h6>
            </Button>
          </Col>

        </Row>}

      <Table striped responsive>
        <thead>
          <tr>
            <th className="border-0" width='85'>Email</th>
            <th className="border-0" width='75'>Bill Number</th>
            <th className="border-0" width='85'>Account Number</th>
            <th className="border-0">Account Type</th>
            <th className="border-0">Bill Date</th>
            <th className="border-0">Amount Due</th>
            <th className="border-0">Due Date</th>
            <th className="border-0">Bill Status</th>
            <th className="border-0">Recurring Bill</th>
            <th className="border-0">Edit Bill</th>
          </tr>
        </thead>
        <tbody>

          {!_.isEmpty(formData.billsData) && formData.billsData.map((record, idx) => {
            let linkText = `/businessbills/${record.billId}`;
            let accountType = getAccountType(record.accountTypeId, formData.accountTypes);
            const editButtonClick = (linkText) => {
              navigate(linkText);
            }
            return (
              <tr key={idx}>
                <td className='text-left'>
                  {record.email}
                </td>
                <td className='text-center'>
                  {record.billNumber}
                </td>
                <td className='text-center'>
                  {record.accountNumber}
                </td>
                <td>
                  {accountType}
                </td>
                <td>
                  {formatDate(stringUTCToLocal(record.billDate))}
                </td>
                <td>
                  {record.amountDue / 100}
                </td>
                <td>
                  {formatDate(stringUTCToLocal(record.dueDate))}
                </td>
                <td>
                  {getBillStatus(record.billStatus)}
                </td>
                <td align="center">
                  {record.recurringBill && <FontAwesomeIcon size="lg" color="green" icon={faCheck} />}
                  {!record.recurringBill && <span>No</span>}
                </td>
                <td>
                  <Button variant="dark" className="border-0 text-dark" onClick={(event) => editButtonClick(linkText)}>
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>
                </td>

              </tr>
            )
          })}
        </tbody>
      </Table>
    </FormContainer>
  )
}
export default BusinessBills;